// Biblioteca de citas de inspiración, agrupadas por tema.
//
// Criterio: solo citas de autores conocidos que se pueden ubicar en una obra
// concreta (poema, novela, ensayo, carta). Las frases "de internet" sin fuente
// se dejaron afuera aunque circulen mucho, porque suelen estar mal atribuidas.
// Las de autores que no escribieron en español van en traducción.
//
// Si se carga una planilla en SHEET_CSV_URL (App.jsx), esa planilla reemplaza
// a esta biblioteca. La planilla equivalente está en docs/citas.csv.

export const QUOTES = {
  despedida: [
    {
      text: "Recuerde el alma dormida, avive el seso y despierte contemplando cómo se pasa la vida, cómo se viene la muerte tan callando.",
      author: "Jorge Manrique",
      source: "Coplas por la muerte de su padre",
    },
    {
      text: "Y yo me iré. Y se quedarán los pájaros cantando.",
      author: "Juan Ramón Jiménez",
      source: "El viaje definitivo",
    },
    {
      text: "Que tenemos que hablar de muchas cosas, compañero del alma, compañero.",
      author: "Miguel Hernández",
      source: "Elegía a Ramón Sijé",
    },
    {
      text: "Cuando estés triste, mira de nuevo en tu corazón y verás que en verdad estás llorando por aquello que fue tu alegría.",
      author: "Khalil Gibran",
      source: "El profeta",
    },
    {
      text: "Y cuando llegue el día del último viaje, y esté al partir la nave que nunca ha de tornar, me encontraréis a bordo ligero de equipaje, casi desnudo, como los hijos de la mar.",
      author: "Antonio Machado",
      source: "Retrato",
    },
  ],
  perdon: [
    {
      text: "Errar es humano; perdonar, divino.",
      author: "Alexander Pope",
      source: "Ensayo sobre la crítica",
    },
    {
      text: "El amor es paciente, es bondadoso. No guarda rencor.",
      author: "San Pablo",
      source: "Primera carta a los Corintios",
    },
    {
      text: "El débil nunca puede perdonar. El perdón es el atributo de los fuertes.",
      author: "Mahatma Gandhi",
      source: "Young India",
    },
    {
      text: "La clemencia no se impone por la fuerza: cae como la suave lluvia del cielo.",
      author: "William Shakespeare",
      source: "El mercader de Venecia",
    },
  ],
  cumpleanos: [
    {
      text: "No es que tengamos poco tiempo, sino que perdemos mucho.",
      author: "Séneca",
      source: "Sobre la brevedad de la vida",
    },
    {
      text: "Juventud, divino tesoro, ¡ya te vas para no volver!",
      author: "Rubén Darío",
      source: "Canción de otoño en primavera",
    },
    {
      text: "Aprovecha el día y confía lo menos posible en el mañana.",
      author: "Horacio",
      source: "Odas",
    },
    {
      text: "Todas las personas mayores fueron al principio niños, aunque pocas de ellas lo recuerdan.",
      author: "Antoine de Saint-Exupéry",
      source: "El principito",
    },
  ],
  felicitaciones: [
    {
      text: "En todo comienzo reside un encanto que nos protege y nos ayuda a vivir.",
      author: "Hermann Hesse",
      source: "Escalones",
    },
    {
      text: "Cuando emprendas tu viaje a Ítaca pide que el camino sea largo, lleno de aventuras, lleno de experiencias.",
      author: "Constantino Kavafis",
      source: "Ítaca",
    },
    {
      text: "Ningún viento es favorable para quien no sabe a qué puerto se dirige.",
      author: "Séneca",
      source: "Cartas a Lucilio",
    },
    {
      text: "Si uno avanza con confianza en la dirección de sus sueños, encontrará un éxito inesperado en las horas comunes.",
      author: "Henry David Thoreau",
      source: "Walden",
    },
  ],
  animo: [
    {
      text: "Caminante, no hay camino, se hace camino al andar.",
      author: "Antonio Machado",
      source: "Proverbios y cantares",
    },
    {
      text: "En medio del invierno aprendí por fin que había en mí un verano invencible.",
      author: "Albert Camus",
      source: "Regreso a Tipasa",
    },
    {
      text: "Donde está el peligro, crece también lo que salva.",
      author: "Friedrich Hölderlin",
      source: "Patmos",
    },
    {
      text: "Al hombre se le puede arrebatar todo salvo una cosa: la última de las libertades humanas, la elección de la actitud personal ante cualquier circunstancia.",
      author: "Viktor Frankl",
      source: "El hombre en busca de sentido",
    },
  ],
  extranar: [
    {
      text: "Si vienes, por ejemplo, a las cuatro de la tarde, desde las tres comenzaré a ser feliz.",
      author: "Antoine de Saint-Exupéry",
      source: "El principito",
    },
    {
      text: "Partir es una pena tan dulce que diré buenas noches hasta que amanezca.",
      author: "William Shakespeare",
      source: "Romeo y Julieta",
    },
    {
      text: "Me gustas cuando callas porque estás como ausente.",
      author: "Pablo Neruda",
      source: "Poema 15",
    },
    {
      text: "Uno se expone a llorar un poco cuando se ha dejado domesticar.",
      author: "Antoine de Saint-Exupéry",
      source: "El principito",
    },
  ],
  amor: [
    {
      text: "¿Qué es poesía? ¿Y tú me lo preguntas? Poesía… eres tú.",
      author: "Gustavo Adolfo Bécquer",
      source: "Rima XXI",
    },
    {
      text: "Por una mirada, un mundo; por una sonrisa, un cielo; por un beso… ¡yo no sé qué te diera por un beso!",
      author: "Gustavo Adolfo Bécquer",
      source: "Rima XXIII",
    },
    {
      text: "Serán ceniza, mas tendrá sentido; polvo serán, mas polvo enamorado.",
      author: "Francisco de Quevedo",
      source: "Amor constante más allá de la muerte",
    },
    {
      text: "Te amo directamente sin problemas ni orgullo: así te amo porque no sé amar de otra manera.",
      author: "Pablo Neruda",
      source: "Cien sonetos de amor, XVII",
    },
    {
      text: "Andábamos sin buscarnos pero sabiendo que andábamos para encontrarnos.",
      author: "Julio Cortázar",
      source: "Rayuela",
    },
    {
      text: "Y en la calle codo a codo somos mucho más que dos.",
      author: "Mario Benedetti",
      source: "Te quiero",
    },
    {
      text: "Amar no es mirarse el uno al otro, sino mirar juntos en la misma dirección.",
      author: "Antoine de Saint-Exupéry",
      source: "Tierra de hombres",
    },
    {
      text: "Mi generosidad es tan ilimitada como el mar, y mi amor tan profundo: cuanto más te doy, más tengo, porque ambos son infinitos.",
      author: "William Shakespeare",
      source: "Romeo y Julieta",
    },
    {
      text: "El amor todo lo disculpa, todo lo cree, todo lo espera, todo lo soporta.",
      author: "San Pablo",
      source: "Primera carta a los Corintios",
    },
    {
      text: "Es tan corto el amor, y es tan largo el olvido.",
      author: "Pablo Neruda",
      source: "Poema 20",
    },
  ],
  familia: [
    {
      text: "Tu risa me hace libre, me pone alas.",
      author: "Miguel Hernández",
      source: "Nanas de la cebolla",
    },
    {
      text: "Hijo: espantado de todo, me refugio en ti.",
      author: "José Martí",
      source: "Ismaelillo",
    },
    {
      text: "El mar sus millares de olas mece, divino. Oyendo a los mares amantes, mezo a mi niño.",
      author: "Gabriela Mistral",
      source: "Meciendo",
    },
    {
      text: "Mi infancia son recuerdos de un patio de Sevilla, y un huerto claro donde madura el limonero.",
      author: "Antonio Machado",
      source: "Retrato",
    },
    {
      text: "Tus hijos no son tus hijos: son los hijos y las hijas del anhelo de la Vida por sí misma.",
      author: "Khalil Gibran",
      source: "El profeta",
    },
  ],
  amistad: [
    {
      text: "Cultivo una rosa blanca, en junio como en enero, para el amigo sincero que me da su mano franca.",
      author: "José Martí",
      source: "Versos sencillos",
    },
    {
      text: "Si me preguntan por qué lo quería, siento que solo puedo responder: porque era él; porque era yo.",
      author: "Michel de Montaigne",
      source: "Ensayos, «De la amistad»",
    },
    {
      text: "La amistad hace más brillantes las alegrías y más livianas las adversidades, porque las divide y las comparte.",
      author: "Marco Tulio Cicerón",
      source: "Sobre la amistad",
    },
    {
      text: "Fue el tiempo que pasaste con tu rosa lo que la hizo tan importante.",
      author: "Antoine de Saint-Exupéry",
      source: "El principito",
    },
    {
      text: "Lo esencial es invisible a los ojos.",
      author: "Antoine de Saint-Exupéry",
      source: "El principito",
    },
    {
      text: "¿Qué es un amigo? Un alma que habita en dos cuerpos.",
      author: "Aristóteles",
      source: "según Diógenes Laercio",
    },
  ],
  agradecimiento: [
    {
      text: "Gracias a la vida, que me ha dado tanto.",
      author: "Violeta Parra",
      source: "Gracias a la vida",
    },
    {
      text: "La gratitud no solo es la mayor de las virtudes, sino la madre de todas las demás.",
      author: "Marco Tulio Cicerón",
      source: "Discurso en defensa de Plancio",
    },
    {
      text: "Quien recibe un beneficio con gratitud ya pagó la primera cuota de su deuda.",
      author: "Séneca",
      source: "Sobre los beneficios",
    },
    {
      text: "De mi abuelo Vero: el buen carácter y la serenidad.",
      author: "Marco Aurelio",
      source: "Meditaciones",
    },
    {
      text: "Gracias quiero dar al divino laberinto de los efectos y de las causas por la diversidad de las criaturas que forman este singular universo.",
      author: "Jorge Luis Borges",
      source: "Otro poema de los dones",
    },
  ],
};

export const THEME_LABELS = {
  despedida: "Despedida",
  perdon: "Perdón",
  cumpleanos: "Cumpleaños",
  felicitaciones: "Felicitaciones",
  animo: "Ánimo",
  extranar: "Te extraño",
  amor: "Amor",
  familia: "Familia",
  amistad: "Amistad",
  agradecimiento: "Agradecimiento",
};

// Se comparan sin tildes y como fragmento ("enamor" matchea "enamorada").
// El orden importa: gana el primer tema que matchea, por eso los temas más
// específicos (despedida, perdón, cumpleaños…) van antes que los generales.
export const THEME_KEYWORDS = {
  despedida: ["fallec", "murio", "muerte", "duelo", "luto", "pesame", "perdida", "despedi", "adios", "descanse en paz", "ya no esta"],
  perdon: ["perdon", "disculp", "arrepent", "lo siento", "pelea", "pelead", "reconcili", "lastime"],
  cumpleanos: ["cumple"],
  felicitaciones: ["felicit", "recibi", "gradu", "egres", "titulo", "logro", "nuevo trabajo", "ascenso", "jubil", "mudanza", "nueva etapa", "exito"],
  animo: ["animo", "fuerza", "dificil", "enferm", "triste", "apoyo", "aliento", "mal momento", "operacion", "recuper", "tratamiento"],
  extranar: ["extran", "lejos", "distancia", "viaj", "exterior", "afuera del pais", "me mude", "se mudo", "se muda", "se va a vivir", "me voy a vivir", "reencuentro"],
  amor: ["amor", "enamor", "pareja", "novio", "novia", "esposo", "esposa", "marido", "mujer", "te amo", "corazon", "casamiento", "boda", "aniversario", "san valentin", "compromiso"],
  familia: ["mama", "madre", "papa", "padre", "hijo", "hija", "hermano", "hermana", "abuel", "nieto", "nieta", "familia", "bebe", "nacimiento"],
  amistad: ["amig", "amistad", "companer"],
  agradecimiento: ["gracias", "agradec", "gratitud", "profe", "maestr", "docente"],
};
